import { DeleteOutlined } from '@ant-design/icons';
import { message, Modal, Tooltip, Typography } from 'antd';
import { InfrastructureInstance } from 'osep-generator-service-client-v1';
import { useState } from 'react';
import useDeleteInfraProjectInstanceMutation from '../hooks/mutations/useDeleteInfraInstanceMutation';

type Props = {
  instance: InfrastructureInstance;
};

const DeleteInfraProjectInstanceButton = ({ instance }: Props) => {
  const { deleteInfraInstance } = useDeleteInfraProjectInstanceMutation();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    setIsLoading(true);
    try {
      await deleteInfraInstance(instance.id);
      setIsModalVisible(false);
      message.success('The instance has been deleted');
    } catch (error) {
      message.error(
        `There was an error while deleting the instance. Please try again or contact the OSEP team.`,
      );
      console.error('Error deleting instance:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Tooltip title="Delete">
        <DeleteOutlined key="delete" onClick={showModal} />
      </Tooltip>
      <Modal
        title="Delete Instance"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Delete"
        cancelText="Cancel"
        confirmLoading={isLoading}
      >
        <Typography.Paragraph>
          You are about to delete instance <b>{instance.name}</b>.
        </Typography.Paragraph>
        <Typography.Paragraph style={{ fontWeight: 'bold', color: 'red' }}>
          All data related to this instance will permanently be deleted.
        </Typography.Paragraph>
        <Typography.Paragraph>
          Re-provisioning this instance later will not possible.
        </Typography.Paragraph>
      </Modal>
    </>
  );
};

export default DeleteInfraProjectInstanceButton;
